var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.image)?_c('v-img',{staticClass:"mx-auto mb-2",attrs:{"src":_vm.image.value,"max-height":"200","max-width":"200"}}):_vm._e(),_c('psi-simple-table',{attrs:{"headers":_vm.headers,"items":_vm.details,"dense":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }